import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';

import { BsPersonPlusFill } from 'react-icons/bs';
import InputMask from 'react-input-mask';
import { toast } from 'react-hot-toast';

import { ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import Input from '~/components/Form/Input';
import { default as api } from '~/services/api2';
import { useAuth } from '~/context/AuthContext';
import { useBills } from '~/context/BillsContext';
import { Button } from 'ui-kit-takeat';
import ChangeAcceptRestaurantTax from '../ChangeAcceptRestaurantTax';
import {
  Container,
  Content,
  ClientButton,
  ReturnButton,
  StyledModal,
} from './styles';

const ClientArea = ({ session_id, session }) => {
  const [modal, setModal] = useState(false);
  const { user } = useAuth();
  const { clientSession } = useBills();

  const [clientInfo, setClientInfo] = useState(clientSession);
  const [clientFinal, setClientFinal] = useState(clientSession);

  const [phone, setPhone] = useState('');
  const formRef = useRef(null);

  useEffect(() => {
    setClientInfo(clientSession);
    setClientFinal(clientSession);
  }, [clientSession]);

  const [showRegister, setShowRegister] = useState(false);

  function toggleModal() {
    setModal(!modal);
    setShowRegister(false);
    if (clientSession) {
      setClientInfo(clientFinal);
    }
  }

  async function getClient(phone) {
    try {
      const response = await api.post('restaurants/get-clients', {
        phone,
      });

      if (response.data.hasClient === true) {
        setClientInfo(response.data.client);
        setShowRegister(false);
      } else {
        setShowRegister(true);
      }
    } catch (error) {
      toast.error(
        'Não foi possível obter informações do cliente! tente novamente'
      );
    }
  }

  async function submitClient(data) {
    if (clientInfo) {
      // Relacionar Cliente Existente a Comanda
      try {
        const response = await api.post('restaurants/clients/relate', {
          session_id,
          id: clientInfo.id,
        });

        setClientInfo(response.data);
        setClientFinal(response.data);
        session.client = response.data;
        toggleModal();
        toast.success('Cliente adicionado a comanda com sucesso!');
      } catch (error) {
        toast.error(
          'Não foi possível adicionar o cliente a comanda! tente novamente'
        );
      }
    } else {
      // Cadastrar Novo Cliente
      if (phone[14] && phone[14] !== '_') {
        try {
          const response = await api.post('restaurants/clients', {
            session_id,
            phone,
            name: data?.name,
            cpf: data?.cpf,
            email: data?.email,
            birthday: data?.birthday,
            cep: data?.cep,
            bairro: data?.bairro,
            street: data?.street,
            number: data?.number,
            complement: data?.complement,
          });

          setClientInfo(response.data);
          setClientFinal(response.data);
          toggleModal();
          toast.success('Cliente adicionado com sucesso!');
        } catch (error) {
          toast.error('Não foi possível finalizar o cadastro! tente novamente');
        }
      } else {
        toast.error('Digite um número de telefone válido');
      }
    }
  }

  async function editClient() {
    try {
      const data = formRef.current.getData();
      const response = await api.put(
        `restaurants/clients/${clientInfo.id}`,
        data
      );
      setClientInfo(response.data);
      if (clientInfo.id === clientFinal?.id) {
        setClientFinal(response.data);
      }
      toast.success('Cliente atualizado com sucesso!');
    } catch (err) {
      toast.error('Não foi possível atualizar o cadastro! tente novamente');
    }
  }

  useEffect(() => {
    if (phone[14] && phone[14] !== '_') {
      getClient(phone);
    }
  }, [phone]);

  return (
    <Container>
      <Content>
        {/* {user?.has_service_tax && !session.tip && (
          <ChangeAcceptRestaurantTax session={session} />
        )} */}
        <ClientButton onClick={() => toggleModal()}>
          {!clientInfo || !clientFinal ? (
            // <h6>
            //   <strong>Cadastrar Cliente</strong>
            // </h6>
            <></>
          ) : (
            <>
              <BsPersonPlusFill size={20} />
              <div style={{ textAlign: 'left' }}>
                <h6>
                  <strong>{clientFinal?.phone}</strong>
                </h6>
                <p style={{ fontSize: '13px' }}>{clientFinal?.name}</p>
              </div>
            </>
          )}
        </ClientButton>
      </Content>

      <StyledModal isOpen={modal} toggle={toggleModal}>
        <Form initialData={clientInfo} onSubmit={submitClient} ref={formRef}>
          <ModalBody>
            {!clientInfo ? (
              <>
                <h5>Cadastrar Cliente na Comanda</h5>
                <div style={{ textAlign: 'center' }}>
                  <p>Pra começar, digite o número de celular do cliente:</p>
                  <InputMask
                    mask="(99) 99999-9999"
                    onChange={(e) => setPhone(e.target.value)}
                  >
                    <Input
                      name="phone_to"
                      type="text"
                      placeholder="(xx) xxxxx-xxxx"
                      style={{
                        width: '40%',
                        margin: 'auto',
                        textAlign: 'center',
                      }}
                    />
                  </InputMask>
                  {showRegister && (
                    <div>
                      <p style={{ color: 'red' }}>
                        Cliente sem cadastro! Finalize o cadastro abaixo:
                      </p>
                      <Row>
                        <Col>
                          <Input
                            name="name"
                            label="Nome: (Opcional)"
                            type="text"
                          />
                        </Col>
                        <Col>
                          <Input
                            name="email"
                            label="E-mail: (Opcional)"
                            type="email"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <InputMask mask="999.999.999-99">
                            <Input
                              name="cpf"
                              label="CPF: (Opcional)"
                              type="text"
                            />
                          </InputMask>
                        </Col>
                        <Col>
                          <InputMask mask="99/99/9999">
                            <Input
                              name="birthday"
                              label="Data de Nascimento: (Opcional)"
                              type="text"
                            />
                          </InputMask>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <InputMask mask="99.999-999">
                            <Input
                              name="cep"
                              label="CEP: (Opcional)"
                              type="text"
                            />
                          </InputMask>
                        </Col>
                        <Col>
                          <Input
                            name="bairro"
                            label="Bairro: (Opcional)"
                            type="text"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Input
                            name="street"
                            label="Rua: (Opcional)"
                            type="text"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Input
                            name="number"
                            label="Nº: (Opcional)"
                            type="text"
                          />
                        </Col>
                        <Col>
                          <Input
                            name="complement"
                            label="Complemento: (Opcional)"
                            type="text"
                          />
                        </Col>
                      </Row>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <Row>
                  <Col md="12" style={{ textAlign: 'center' }}>
                    <h4>{clientInfo?.phone}</h4>
                    <p style={{ color: 'green' }}>Cliente já cadastrado!</p>
                    <ReturnButton
                      onClick={() => {
                        setClientInfo(null);
                      }}
                    >
                      Mudar número
                    </ReturnButton>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input name="name" label="Nome: (Opcional)" type="text" />
                  </Col>
                  <Col>
                    <Input
                      name="email"
                      label="E-mail: (Opcional)"
                      type="email"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputMask mask="999.999.999-99">
                      <Input name="cpf" label="CPF: (Opcional)" type="text" />
                    </InputMask>
                  </Col>
                  <Col>
                    <InputMask mask="99/99/9999">
                      <Input
                        name="birthday"
                        label="Data de Nascimento: (Opcional)"
                        type="text"
                      />
                    </InputMask>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputMask mask="99.999-999">
                      <Input name="cep" label="CEP: (Opcional)" type="text" />
                    </InputMask>
                  </Col>
                  <Col>
                    <Input
                      name="bairro"
                      label="Bairro: (Opcional)"
                      type="text"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input name="street" label="Rua: (Opcional)" type="text" />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input name="number" label="Nº: (Opcional)" type="text" />
                  </Col>
                  <Col>
                    <Input
                      name="complement"
                      label="Complemento: (Opcional)"
                      type="text"
                    />
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            {clientInfo && clientInfo.phone !== clientFinal?.phone && (
              <Button
                style={{ width: '100%' }}
                onClick={() => editClient()}
                buttonColor="#17a2b8"
                title="Atualizar Informações do Cliente"
              />
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Button onClick={toggleModal} title="Fechar" type="button" />

              {clientInfo && clientInfo.phone !== clientFinal?.phone && (
                <Button
                  type="submit"
                  buttonColor="#2ec9b7"
                  title="Adicionar a Comanda"
                  onClick={() => {}}
                />
              )}

              {showRegister && (
                <Button
                  type="submit"
                  buttonColor="#2ec9b7"
                  title="Cadastrar e Adicionar a Comanda"
                  onClick={() => {}}
                />
              )}
            </div>
          </ModalFooter>
        </Form>
      </StyledModal>
    </Container>
  );
};

export default ClientArea;
